import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zeroFox = defineConnector({
  identifier: "zeroFox",
  name: "ZeroFox",
  tagLine: "Digital risk protection",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.zerofox\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        scheme: "Token",
        value: app.secret.apiToken,
      },
    ]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to the [ZeroFox platform](https://cloud.zerofox.com/) and open **Settings › Account › API** to find your personal API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.zerofox.com/1.0/alerts/",
  },
});
